<div #searchContainer class="search-container">
  <mat-icon class="search-icon">search</mat-icon>
  <input
    type="text"
    [(ngModel)]="searchTerm"
    (input)="onSearchChange()"
    (focus)="onInputFocus()"
    (blur)="onInputBlur($event)"
    placeholder="Search..."
    class="input-box"
    #input
    (keyup.enter)="onEnterKey()"
  />

  @if (showSuggestedPanel) {
    <div #searchInput class="suggestions-dropdown">
      @if (searchTerm.length < 2 && !isFilterSelected) {
        <div class="section-title">{{ page }} SUGGESTED FILTERS</div>

        <!-- @if (searchFilteredData.length === 0) { -->
        @for (filter of suggestedFilters; track filter.key) {
          <div class="filter-item" (click)="onSelect(filter)">
            <div class="filter-tags">
              <div class="filtered-data" class="text-muted">
                <span
                  class="filter-key filtered-data"
                  [innerHTML]="filter.key + ':' | highlight: searchTerm ?? ''"
                ></span>
              </div>
              <div>
                <span
                  class="filter-value"
                  [innerHTML]="
                    filter.key + ': ' + filter.value
                      | highlight: searchTerm ?? ''
                  "
                ></span>
              </div>
            </div>
            <div class="filter-desc-wrapper">
              <span class="filter-desc" [innerHTML]="filter.description"></span>
            </div>
          </div>
        }
      } @else if (nestedFilters.length > 0) {
        <div class="section-title">Select {{ searchTermKey }}</div>

        <!-- Show nested filters dynamically -->
        @for (filter of nestedFilters; track filter.key) {
          <div class="filter-item" (click)="onSelectNested(filter)">
            <span
              class="filter-value"
              [innerHTML]="
                filter.key + ': ' + filter.value | highlight: searchTerm ?? ''
              "
            ></span>
          </div>
        }
      } @else {
        <div class="section-title">
          <b>{{ page }}</b> Connected Results
        </div>
        <app-filter-grid
          [gridColumns]="columns"
          [gridData]="searchFilteredData"
          [page]="page"
          (onSelectRow)="onSelectRow($event)"
          [searchTerm]="searchTerm"
        ></app-filter-grid>
      }

      <!-- TODO: Uncomment with proper document in future -->
      <!-- <div class="search-tips" (click)="onSearchTipsClick()">
        <mat-icon>info_outline</mat-icon>
        <span>Search tips</span>
      </div> -->
    </div>
  }
</div>
